import { useTranslation } from "react-i18next";

export default function TrustSafety() {
  const { t } = useTranslation();

  return (
    <section id="safety" className="py-16 md:py-24 bg-background-50">
      <div className="container-custom">
        <div className="relative bg-foreground-900 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            <div className="lg:w-[38%] relative min-h-[320px] lg:min-h-[500px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Detailed%20closeup%20of%20a%20quality%20inspection%20moment%20showing%20hands%20examining%20fabric%20texture%20and%20stitching%20of%20a%20garment%20on%20a%20clean%20white%20worktable%2C%20bright%20even%20studio%20lighting%2C%20editorial%20craftsmanship%20photography%2C%20no%20text%2C%20authenticity%20verification%20aesthetic&width=600&height=800&seq=trust-img-v2-v&orientation=portrait"
                alt="Verified products"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div className="lg:w-[62%] flex flex-col justify-center px-8 md:px-12 py-10 md:py-14">
              <span className="text-6xl md:text-8xl font-heading text-white/10 leading-none mb-4 select-none">"</span>
              <p className="text-lg md:text-xl lg:text-2xl text-white font-medium leading-relaxed mb-8 max-w-lg">
                {t("home:trustContent", "We manually verify every spreadsheet entry to ensure you get only legitimate product links.")}
              </p>
              <div className="mb-8">
                <p className="text-sm text-white/80 font-medium">
                  {t("home:trustSignature", "AllChinaBuy Team")}
                </p>
                <p className="text-xs text-white/50 mt-1">
                  {t("home:trustSince", "Verified Since 2024")}
                </p>
              </div>
              <a
                href="#safety"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-500/20 text-accent-200 text-sm font-medium hover:bg-accent-500/30 transition-all whitespace-nowrap cursor-pointer w-fit"
              >
                {t("home:trustCTA", "Learn About Our Process")} <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}